<script setup lang="ts">
const {
  label = null,
  labelIcon = null,
  value = null,
  valueIcon = null,
  labelProps = {},
  valueProps = {}
} = defineProps<{
  label?: string | null;
  labelIcon?: string | null;
  value?: string | null;
  valueIcon?: string | null;
  labelProps?: Record<string, unknown>;
  valueProps?: Record<string, unknown>;
}>();
</script>

<template>
  <div class="key-value">
    <dt v-bind="labelProps" data-testid="key-value-label">
      <slot v-if="labelIcon" name="labelIcon">
        <v-icon :icon="labelIcon" size="1em" />
      </slot>
      <slot name="label">{{ label }}</slot>
    </dt>
    <dd v-bind="valueProps" data-testid="key-value-value">
      <slot v-if="valueIcon" name="valueIcon">
        <v-icon :icon="valueIcon" size="1em" />
      </slot>
      <slot name="value">{{ value }}</slot>
    </dd>
    <slot></slot>
  </div>
</template>
<style lang="scss" scoped>
dt .v-icon {
  margin: 0 6px 2px 0;
}

dd .v-icon {
  margin: 0 6px 1px 0;
}
</style>
